import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { CovalentMessageModule } from '@covalent/core/message';
import { ToastrModule } from 'ngx-toastr';
import { AlertDialogComponent } from 'src/app/shared/components/alert-dialog/alert-dialog.component';
import { OperationAlertComponent } from 'src/app/shared/operation-alert/operation-alert.component';
import { OperationErrorAlertDetailsComponent } from 'src/app/shared/operation-error-alert-details/operation-error-alert-details.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@NgModule({
  declarations: [
    OperationAlertComponent,
    OperationErrorAlertDetailsComponent,
    AlertDialogComponent,
  ],
  imports: [
    CommonModule,
    ToastrModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSnackBarModule,
    MatInputModule,
    CovalentMessageModule,
    ReactiveFormsModule,
    MatDividerModule,
  ],
})
export class TcsToastModule {
  public static forRoot(): ModuleWithProviders<TcsToastModule> {
    return {
      ngModule: TcsToastModule,
      providers: ToastrModule.forRoot().providers,
    };
  }
}
